// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalInner_modal__1O1Dn","modalContent":"ModalInner_modalContent__Kt1nK"};